import { defineGame } from "./game-definition.js";
import { QUIZ_BUZZER_PHASES, canTransitionQuizBuzzer, scoreQuizAnswer, transitionQuizBuzzer } from "./quiz-buzzer-machine.js";
export const QUIZ_BUZZER_DEFAULT_CONFIG = Object.freeze({
    rounds: 10,
    answerDurationMs: 15_000,
    roundResultDurationMs: 5_000,
    correctBasePoints: 1_000,
    speedBonusMaxPoints: 500
});
const actions = ["START", "ANSWER", "ROUND_COMPLETE", "NEXT_ROUND", "FINISH", "PAUSE", "RESUME", "SKIP_ROUND", "END", "PLAY_AGAIN"];
export const QUIZ_BUZZER_DEFINITION = defineGame({
    key: "QUIZ_BUZZER",
    metadata: {
        slug: "quiz-buzzer",
        name: "Quiz Buzzer",
        description: "Domande a quattro risposte con punti bonus per la rapidità.",
        icon: "❓",
        catalogStatus: "available",
        maturity: "beta",
        hostAccess: true,
        minimumPlayers: 1,
        maximumPlayers: 100,
        capabilities: ["realtime", "qr-join", "public-display", "persistent-ranking", "questions"]
    },
    initialConfig: QUIZ_BUZZER_DEFAULT_CONFIG,
    supportedConfiguration: ["rounds", "answerDurationMs", "roundResultDurationMs", "correctBasePoints", "speedBonusMaxPoints"],
    configurationProfiles: {
        quick: { configuration: { rounds: 5, answerDurationMs: 10_000, roundResultDurationMs: 3_000 }, estimatedMinutes: 4 },
        standard: { configuration: {}, estimatedMinutes: 7 },
        extended: { configuration: { rounds: 20, answerDurationMs: 18_000, roundResultDurationMs: 4_000 }, estimatedMinutes: 15 }
    },
    createInitialState: (config = {}) => ({ phase: "LOBBY", roundNumber: 0, totalRounds: config.rounds ?? QUIZ_BUZZER_DEFAULT_CONFIG.rounds, pausedFromPhase: null }),
    states: QUIZ_BUZZER_PHASES,
    actions,
    canTransition: (state, action) => canTransitionQuizBuzzer(state.phase, action),
    transition: (state, action) => ({
        ...state,
        phase: transitionQuizBuzzer(state.phase, action, state.pausedFromPhase === "QUESTION" || state.pausedFromPhase === "ROUND_RESULT" ? { resumePhase: state.pausedFromPhase } : {})
    }),
    scoreDelta: (decision) => scoreQuizAnswer(decision === "CORRECT", QUIZ_BUZZER_DEFAULT_CONFIG.answerDurationMs, QUIZ_BUZZER_DEFAULT_CONFIG.answerDurationMs, QUIZ_BUZZER_DEFAULT_CONFIG),
    views: { host: "quiz-buzzer/host", player: "quiz-buzzer/player", display: "quiz-buzzer/display" },
    realtime: {
        clientToServer: ["host:start", "host:pause", "host:resume", "host:skip-round", "host:end", "host:play-again", "player:answer"],
        serverToClient: ["action-result", "action-error", "answer-result"]
    }
});
//# sourceMappingURL=quiz-buzzer-definition.js.map